import { createAction, props } from '@ngrx/store';
import { PagedOrders, OrderFiltersState } from 'src/app/core/orders/models/orders.models';


export const updateFilters = createAction(
  '[Filters] Update Filters',
  props<{ filters: Partial<OrderFiltersState> }>() 
);

export const cleanFilters = createAction(
  '[Filters] Clean Filters'
);

export const cleanOneFilter = createAction(
  '[Filters] Clean One Filter',
  props<{ filter: string }>() 
);

export const applyFilters = createAction(
  '[Filters] Apply Filters',
  props<{ filters: any }>()
);